import * as React from "react";
import { Button, Grid } from "../widget";
import UploadFilesDialog from "./UploadFilesDialog";
import FilesList from "./FilesList";
import { FileInfo } from "./FileInfo";

export interface FileUploaderProps
{
    id: string;
    stateChanged: (state: FileUploaderState) => void;
    uploadedFiles: Array<FileInfo>;
    uploadFileUrl: string;
    maxFiles: number;
    allowedExtensions: string[];
}

export interface FileUploaderState
{
    showDialog: boolean;
    files: Array<FileInfo>;
}

type PropsType = FileUploaderProps;


class FileUploader extends React.PureComponent<PropsType, FileUploaderState> {

    constructor(props: PropsType)
    {
        super(props);
        this.state = {
            showDialog: false,
            files: this.props.uploadedFiles,
        }
    }

    closeDialog = (uploadedFiles?: FileInfo[]) =>
    {
        this.setState(state =>
        {

            const newFiles = state.files.concat(uploadedFiles || []);
            this.props.stateChanged({ ...state, files: newFiles });
            return {
                showDialog: false,
                files: newFiles
            };
        });
    }

    removeFile = (fileInfo: FileInfo) =>
    {
        this.setState(state =>
        {
            const newFiles = state.files.slice(0);
            const index = newFiles.indexOf(fileInfo);
            if (index >= 0) {
                newFiles.splice(index, 1);
            }
            this.props.stateChanged({ ...state, files: newFiles });
            return { files: newFiles };
        });
    }

    render()
    {
        const { showDialog, files } = this.state;
        const { uploadFileUrl, maxFiles, allowedExtensions, id } = this.props;

        return <div id={id}>
            <Grid container direction="column" spacing={8}>
                <Grid item>
                    <FilesList items={files} removeFile={this.removeFile} />
                </Grid>
                {files.length < maxFiles ? <Grid item>
                    <Button color="primary" variant="outlined" onClick={() => this.setState({ showDialog: true })} disabled={showDialog}>{'Vložit soubor'}</Button>
                </Grid> : null}
                <UploadFilesDialog show={showDialog} onClose={this.closeDialog} uploadFileUrl={uploadFileUrl} maxFiles={maxFiles} allowedExtensions={allowedExtensions} />
            </Grid>
        </div>;

    }
}


export default FileUploader;